import { UpgradableNumber } from "@dndModels/misc";
import { DominanceGroupType, WorldSetting } from "@dndModels/Types";

export class CharacterOptions {
  source_books: string[] = [];
  blocked: string[] = [];
  // blocked_races: string[] = [];
  // blocked_classes: string[] = [];
  // blocked_gifts: string[] = [];
  allow_homebrew = false;
  allow_UA = false;
  allow_3rd_party = false;
  allow_archives = false;
  allow_monster_feature_sources = false;
  bonus_skill_profs_for_int = false;
  allow_level_0 = false;
  level_0X_weapon_profs = 0;
  level_0X_armor_profs = 0;
  level_0X_save_profs = 0;
  level_0X_skill_profs = 0;
  potions_ba = false;
  potion_max_on_action = false;
  use_leveled_potions = false;
  leveled_potion_dice_size = 4;
  leveled_potion_bonus_multiplier = 1;
  leveled_potion_max_size = 10;
  free_weapon_profs: string[] = [];
  custom_origins = false;
  optional_features = false;
  player_control_for_gifts = false;
  show_extra_conditions: string[] = [];
  ability_score_gen_method: "Any" | "Point Buy" | "Standard Array" | "Manual/Rolled" | "Not Manual/Rolled" = "Any";
  standard_array: number[] = [8,10,12,13,14,15];
  points = 27;
  point_mapping: { [ability_score: number]: number } = {
    8: 0, 
    9: 1, 
    10: 2, 
    11: 3, 
    12: 4,
    13: 5,
    14: 7,
    15: 9
  };
  display_unfit_items: string[] = [];
  ignore_limitations: string[] = [];
  // edition_id: string = "Any";
  use_coin_weight = false;
  use_encumbrance_effects = false;
  encumbrance_id = "63262beb42f1ba1f88dbab66";
  exhaustion_id = "66eccd857b715e93871395dc";
  use_suggestions = true;
  show_extra_action_types = false;
  light_melee_action: "Action" | "Bonus Action" = "Action";
  heavy_weapon_rule: "Disadvantage from Size" | "Disadvantage from Ability Score" = "Disadvantage from Ability Score";
  use_turn_resources = false;
  use_mini_night_rests = false;
  use_spell_infusions = false;
  mini_rest_description = "";
  night_rest_description = "";
  short_rest_description = "";
  long_rest_description = "";
  attunement_slots: UpgradableNumber = new UpgradableNumber(3);
  // weapon_mastery_type: "Weapon Type" | "Mastery" = "Weapon Type";
  allow_multiclassing = true;
  ignore_multiclassing_rules = false;
  use_item_crafting = false;
  races_called: "Race" | "Species" = "Race";
  standard_features_id = "66e84acf4f9dc57b11af960d";
  dominant_variants_only: DominanceGroupType[] = ["Race/Species","Background","Class","Eldritch Invocation","Feat","Item","Spell","Subclass","Subrace/Lineage"];
  single_option_feat_flexibility = true;
  asi_flexibility = true;
  asis_on: "Race/Species" | "Background" = "Background";
  use_bastions = false;
  allow_wild_talent = false;
  world_settings: WorldSetting[] = ["Any"];

  get allow_eberron() {
    return this.world_settings.includes("Any") || this.world_settings.includes("Eberron");
  }

  constructor(obj?: any) {
    if (obj) {
      this.source_books = [];
      if (obj.source_books) {
        for (const source_book of obj.source_books) {
          if (!this.source_books.includes(source_book)) {
            this.source_books.push(source_book);
          }
        }
      }
      this.blocked = obj.blocked ? obj.blocked : [];
      if (!obj.blocked) {
        if (obj.blocked_races) {
          this.blocked.push(...obj.blocked_races);
        }
        if (obj.blocked_classes) {
          this.blocked.push(...obj.blocked_classes);
        }
        if (obj.blocked_gifts) {
          this.blocked.push(...obj.blocked_gifts);
        }
      }
      // this.blocked_races = obj.blocked_races ? [...obj.blocked_races] : [];
      // this.blocked_classes = obj.blocked_classes ? [...obj.blocked_classes] : [];
      // this.blocked_gifts = obj.blocked_gifts ? [...obj.blocked_gifts] : [];
      this.allow_homebrew = obj.allow_homebrew ? obj.allow_homebrew : false;
      this.allow_UA = obj.allow_UA ? obj.allow_UA : false;
      this.allow_3rd_party = obj.allow_3rd_party ? obj.allow_3rd_party : false;
      this.allow_archives = obj.allow_archives ? obj.allow_archives : false;
      this.allow_monster_feature_sources = obj.allow_monster_feature_sources ? obj.allow_monster_feature_sources : false;
      this.allow_level_0 = obj.allow_level_0 ? obj.allow_level_0 : false;
      this.bonus_skill_profs_for_int = obj.bonus_skill_profs_for_int ? obj.bonus_skill_profs_for_int : false;
      this.potions_ba = obj.potions_ba ? obj.potions_ba : false;
      this.potion_max_on_action = obj.potion_max_on_action ? obj.potion_max_on_action : false;
      this.use_leveled_potions = obj.use_leveled_potions ? obj.use_leveled_potions : false;
      this.leveled_potion_dice_size = obj.leveled_potion_dice_size ? obj.leveled_potion_dice_size : 4;
      this.leveled_potion_bonus_multiplier = obj.leveled_potion_bonus_multiplier ? obj.leveled_potion_bonus_multiplier : 1;
      this.leveled_potion_max_size = obj.leveled_potion_max_size ? obj.leveled_potion_max_size : 10;
      this.custom_origins = obj.custom_origins ? obj.custom_origins : false;
      this.optional_features = obj.optional_features ? obj.optional_features : false;
      this.player_control_for_gifts = obj.player_control_for_gifts ? obj.player_control_for_gifts : false;
      this.show_extra_conditions = obj.show_extra_conditions ? [...obj.show_extra_conditions] : [];
      this.ability_score_gen_method = obj.ability_score_gen_method ? obj.ability_score_gen_method : "Any";
      this.standard_array = obj.standard_array ? [...obj.standard_array] : [8,10,12,13,14,15];
      this.points = obj.points ? +obj.points : 27;
      this.point_mapping = obj.point_mapping ? {...obj.point_mapping} : { 8: 0, 9: 1, 10: 2, 11: 3, 12: 4, 13: 5, 14: 7, 15: 9 };
      this.display_unfit_items = obj.display_unfit_items ? [...obj.display_unfit_items] : [];
      this.ignore_limitations = obj.ignore_limitations ? [...obj.ignore_limitations] : [];
      // this.edition_id = obj.edition_id ? obj.edition_id : "Any";
      this.use_coin_weight = obj.use_coin_weight ? obj.use_coin_weight : false;
      this.use_encumbrance_effects = obj.use_encumbrance_effects ? obj.use_encumbrance_effects : false;
      this.encumbrance_id = obj.encumbrance_id ? obj.encumbrance_id : "63262beb42f1ba1f88dbab66";
      this.exhaustion_id = obj.exhaustion_id ? obj.exhaustion_id : "66eccd857b715e93871395dc";
      this.use_suggestions = obj.use_suggestions !== undefined ? obj.use_suggestions : true;
      this.show_extra_action_types = obj.show_extra_action_types ? obj.show_extra_action_types : false;
      this.light_melee_action = obj.light_melee_action ? obj.light_melee_action : "Action";
      this.heavy_weapon_rule = obj.heavy_weapon_rule ? obj.heavy_weapon_rule : "Disadvantage from Ability Score";
      if (this.heavy_weapon_rule !== "Disadvantage from Size") {
        this.heavy_weapon_rule = "Disadvantage from Ability Score";
      }

      this.use_turn_resources = obj.use_turn_resources ? obj.use_turn_resources : false;
      this.use_mini_night_rests = obj.use_mini_night_rests ? obj.use_mini_night_rests : false;
      this.use_spell_infusions = obj.use_spell_infusions ? obj.use_spell_infusions : false;
      this.mini_rest_description = obj.mini_rest_description ? obj.mini_rest_description : "A mini rest is a period of downtime, generally at least 1 hour long, during which a character does nothing more strenuous than eating, drinking, reading, and tending to wounds.";
      this.short_rest_description = obj.short_rest_description ? obj.short_rest_description : 
        "A short rest is a period of downtime, generally at least 1 hour long, during which a character does nothing more strenuous than eating, drinking, reading, and tending to wounds.";
      this.long_rest_description = obj.long_rest_description ? obj.long_rest_description : 
        (this.use_mini_night_rests ? 
          "A long rest is a period of extended downtime, generally at least a week long, during which a character doesn't do any major adventuring activities. \n\r It can be used to exercise, research, travel, etc. but any truly life threatening activities will interrupt it, and characters will need to begin again." : 
          "A long rest is a period of extended downtime, generally at least 8 hours long, during which a character sleeps for at least 6 hours (this can be changed by some features), and performs no more than 2 hours of light activity, such as reading, talking, eating, or standing watch. \n\r If the rest is interrupted by a period of strenuous activity (fighting, casting spells, at least 1 hour of walking, or similar adventuring activity) the characters may need to begin the rest again to gain any benefit from it.");
      this.night_rest_description = obj.night_rest_description ? obj.night_rest_description : "A night rest is a period of extended downtime, generally at least 8 hours long, during which a character sleeps for at least 6 hours (this can be changed by some features), and performs no more than 2 hours of light activity, such as reading, talking, eating, or standing watch. /n/r If the rest is interrupted by a period of strenuous activity (fighting, casting spells, at least 1 hour of walking, or similar adventuring activity) the characters may need to begin the rest again to gain any benefit from it.";
      this.attunement_slots = obj.attunement_slots ? new UpgradableNumber(obj.attunement_slots) : new UpgradableNumber(3);
      this.allow_multiclassing = obj.allow_multiclassing !== undefined ? obj.allow_multiclassing : true;
      this.ignore_multiclassing_rules = obj.ignore_multiclassing_rules ? obj.ignore_multiclassing_rules : false;
      // this.weapon_mastery_type = obj.weapon_mastery_type ? obj.weapon_mastery_type : "Weapon Type";
      this.use_item_crafting = obj.use_item_crafting ? obj.use_item_crafting : false;
      this.races_called = obj.races_called ? obj.races_called : "Race";
      this.standard_features_id = obj.standard_features_id ? obj.standard_features_id : "66e84acf4f9dc57b11af960d";
      this.dominant_variants_only = obj.dominant_variants_only ? obj.dominant_variants_only : ["Race/Species","Background","Class","Eldritch Invocation","Feat","Item","Spell","Subclass","Subrace/Lineage"];
      this.single_option_feat_flexibility = obj.single_option_feat_flexibility ? obj.single_option_feat_flexibility : true;
      this.asi_flexibility = obj.asi_flexibility !== undefined ? obj.asi_flexibility : true;
      this.asis_on = obj.asis_on ? obj.asis_on : "Background";
      this.use_bastions = obj.use_bastions ? obj.use_bastions : false;
      this.allow_wild_talent = obj.allow_wild_talent ? obj.allow_wild_talent : false;
      this.world_settings = obj.world_settings ? obj.world_settings : ["Any"];
    }
  }

  toDBObj(): any {
    return {
      source_books: this.source_books,
      allow_homebrew: this.allow_homebrew,
      allow_UA: this.allow_UA,
      allow_3rd_party: this.allow_3rd_party,
      allow_archives: this.allow_archives,
      allow_monster_feature_sources: this.allow_monster_feature_sources,
      allow_level_0: this.allow_level_0,
      bonus_skill_profs_for_int: this.bonus_skill_profs_for_int,
      potions_ba: this.potions_ba,
      potion_max_on_action: this.potion_max_on_action,
      use_leveled_potions: this.use_leveled_potions,
      leveled_potion_dice_size: this.leveled_potion_dice_size,
      leveled_potion_bonus_multiplier: this.leveled_potion_bonus_multiplier,
      leveled_potion_max_size: this.leveled_potion_max_size,
      custom_origins: this.custom_origins,
      optional_features: this.optional_features,
      player_control_for_gifts: this.player_control_for_gifts,
      show_extra_conditions: this.show_extra_conditions,
      ability_score_gen_method: this.ability_score_gen_method,
      standard_array: this.standard_array,
      points: this.points,
      point_mapping: this.point_mapping,
      blocked: this.blocked,
      // blocked_races: this.blocked_races,
      // blocked_classes: this.blocked_classes,
      // blocked_gifts: this.blocked_gifts,
      display_unfit_items: this.display_unfit_items,
      ignore_limitations: this.ignore_limitations,
      // edition_id: this.edition_id,
      use_coin_weight: this.use_coin_weight,
      use_encumbrance_effects: this.use_encumbrance_effects,
      encumbrance_id: this.encumbrance_id,
      exhaustion_id: this.exhaustion_id,
      use_suggestions: this.use_suggestions,
      show_extra_action_types: this.show_extra_action_types,
      light_melee_action: this.light_melee_action,
      heavy_weapon_rule: this.heavy_weapon_rule,
      use_turn_resources: this.use_turn_resources,
      use_mini_night_rests: this.use_mini_night_rests,
      use_spell_infusions: this.use_spell_infusions,
      mini_rest_description: this.mini_rest_description,
      night_rest_description: this.night_rest_description,
      short_rest_description: this.short_rest_description,
      long_rest_description: this.long_rest_description,
      attunement_slots: this.attunement_slots.toDBObj(),
      allow_multiclassing: this.allow_multiclassing,
      ignore_multiclassing_rules: this.ignore_multiclassing_rules,
      // weapon_mastery_type: this.weapon_mastery_type,
      use_item_crafting: this.use_item_crafting,
      races_called: this.races_called,
      standard_features_id: this.standard_features_id,
      dominant_variants_only: this.dominant_variants_only,
      single_option_feat_flexibility: this.single_option_feat_flexibility,
      asi_flexibility: this.asi_flexibility,
      asis_on: this.asis_on,
      use_bastions: this.use_bastions,
      allow_wild_talent: this.allow_wild_talent,
      world_settings: this.world_settings
    };
  }

  copy(copyMe: CharacterOptions): void {
    this.source_books = copyMe.source_books;
    this.allow_homebrew = copyMe.allow_homebrew;
    this.allow_UA = copyMe.allow_UA;
    this.allow_3rd_party = copyMe.allow_3rd_party;
    this.allow_archives = copyMe.allow_archives;
    this.allow_monster_feature_sources = copyMe.allow_monster_feature_sources;
    this.allow_level_0 = copyMe.allow_level_0;
    this.bonus_skill_profs_for_int = copyMe.bonus_skill_profs_for_int;
    this.potions_ba = copyMe.potions_ba;
    this.potion_max_on_action = copyMe.potion_max_on_action;
    this.use_leveled_potions = copyMe.use_leveled_potions;
    this.leveled_potion_dice_size = copyMe.leveled_potion_dice_size;
    this.leveled_potion_bonus_multiplier = copyMe.leveled_potion_bonus_multiplier;
    this.leveled_potion_max_size = copyMe.leveled_potion_max_size;
    this.custom_origins = copyMe.custom_origins;
    this.optional_features = copyMe.optional_features;
    this.player_control_for_gifts = copyMe.player_control_for_gifts;
    this.show_extra_conditions = [...copyMe.show_extra_conditions];
    this.ability_score_gen_method = copyMe.ability_score_gen_method;
    this.standard_array = [...copyMe.standard_array];
    this.points = copyMe.points;
    this.point_mapping = {...copyMe.point_mapping};
    this.blocked = [...copyMe.blocked];
    // this.blocked_races = [...copyMe.blocked_races];
    // this.blocked_classes = [...copyMe.blocked_classes];
    // this.blocked_gifts = [...copyMe.blocked_gifts];
    this.display_unfit_items = [...copyMe.display_unfit_items];
    this.ignore_limitations = [...copyMe.ignore_limitations];
    // this.edition_id = copyMe.edition_id;
    this.use_coin_weight = copyMe.use_coin_weight;
    this.use_encumbrance_effects = copyMe.use_encumbrance_effects;
    this.encumbrance_id = copyMe.encumbrance_id;
    this.exhaustion_id = copyMe.exhaustion_id;
    this.use_suggestions = copyMe.use_suggestions;
    this.show_extra_action_types = copyMe.show_extra_action_types;
    this.light_melee_action = copyMe.light_melee_action;
    this.heavy_weapon_rule = copyMe.heavy_weapon_rule;
    this.use_turn_resources = copyMe.use_turn_resources;
    this.use_mini_night_rests = copyMe.use_mini_night_rests;
    this.use_spell_infusions = copyMe.use_spell_infusions;
    this.mini_rest_description = copyMe.mini_rest_description;
    this.night_rest_description = copyMe.night_rest_description;
    this.short_rest_description = copyMe.short_rest_description;
    this.long_rest_description = copyMe.long_rest_description;
    this.attunement_slots = copyMe.attunement_slots.clone();
    this.allow_multiclassing = copyMe.allow_multiclassing;
    this.ignore_multiclassing_rules = copyMe.ignore_multiclassing_rules;
    // this.weapon_mastery_type = copyMe.weapon_mastery_type;
    this.use_item_crafting = copyMe.use_item_crafting;
    this.races_called = copyMe.races_called;
    this.standard_features_id = copyMe.standard_features_id;
    this.dominant_variants_only = [...copyMe.dominant_variants_only];
    this.single_option_feat_flexibility = copyMe.single_option_feat_flexibility;
    this.asi_flexibility = copyMe.asi_flexibility;
    this.asis_on = copyMe.asis_on;
    this.use_bastions = copyMe.use_bastions;
    this.allow_wild_talent = copyMe.allow_wild_talent;
    this.world_settings = [...copyMe.world_settings];
  }

  clone(): CharacterOptions {
    const new_obj = new CharacterOptions();
    new_obj.copy(this);
    return new_obj;
  }
}